import React from "react";

export const HomeIcon = ({ stroke = "#113357" }: { stroke?: string }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.28542 7.14167V15.2131C3.28542 15.4892 3.50927 15.7131 3.78542 15.7131H14.214C14.4901 15.7131 14.714 15.4892 14.714 15.2131V7.14167"
        stroke={stroke}
        strokeWidth="1.2"
      />
      <path
        d="M11.2854 15.7167L11.2854 12.2167C11.2854 11.9405 11.0616 11.7167 10.7854 11.7167L7.21399 11.7167C6.93784 11.7167 6.71399 11.9405 6.71399 12.2167L6.71399 15.7167"
        stroke={stroke}
        strokeWidth="1.2"
      />
      <path
        d="M1 9.42857L8.93013 2.31033C9.12504 2.13538 9.42194 2.14048 9.61072 2.32204L17 9.42857"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
